define('../app/fukit/configuration/cayuse.task.list.collection.configuration',['require','exports','module','../model/cayuse.task.list.model','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var CayuseTaskListModel = require('../model/cayuse.task.list.model'),
      Radio               = require('backbone.radio');

  var CayuseTaskListCollectionConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
      'app ready': 'onAppReady',
    },

    // Defining the constructor class for the task list collection in this manner allows us to replace it with
    // a custom collection configured for specific product data.
    CayuseTaskListCollectionConstructor: CayuseTaskListModel.Collection,

    // Create and register the collection onAppConfigure
    onAppConfigure: function(app) {
      this.cayuseTaskListCollection = new this.CayuseTaskListCollectionConstructor();

      Radio.request(
        'AppKit.resourceService',
        'registerResource',
        'cayuseTaskListCollection',
        this.cayuseTaskListCollection
      );
    },

    // Delay fetching the task list collection until the app has fired a ready event because most products
    // will probably need to be aware of the current user, and that data is guaranteed available onAppReady
    onAppReady: function() {
      this.cayuseTaskListCollection.fetch();
    },
  };
  module.exports = CayuseTaskListCollectionConfiguration;
});

